import { styled } from "@l2r-front/l2r-ui"

export const ColorContainer = styled("div")(() => ({
    backgroundColor: "white",
    borderRadius: "12px 0 0 12px",
    height: "100%",
    width: 48,
    flex: "0 0 auto",
    overflow: "hidden",
}))

type StyledColorProps = {
    color: string
}

export const Color = styled("div")<StyledColorProps>(({ color }) => ({
    backgroundColor: color,
    height: "100%",
    width: "100%",
}))